import { BOLETO_DISCOUNT_RATE, PIX_DISCOUNT_RATE } from "./paymentDiscount.ts";

export { BOLETO_DISCOUNT_RATE, PIX_DISCOUNT_RATE };
import { maxCardInstallments } from "./installments.ts";

// Página do produto: até 10x, com a mesma parcela mínima do checkout
// (R$ 50,00, lib/commerce/installments.ts).
const MAX_INSTALLMENTS = 10;

export interface ProductPaymentInfo {
  currentPrice: number;
  pixPrice: number;
  /** Preço com o desconto do boleto (5%), o mesmo aplicado no checkout. */
  boletoPrice: number;
  installments: number;
  installmentValue: number;
  installmentOptions: ProductInstallmentOption[];
  isVariable: boolean;
}

export interface ProductInstallmentOption {
  installments: number;
  installmentValue: number;
  total: number;
}

interface GetProductPaymentInfoOptions {
  currentPrice: number;
  isVariable?: boolean;
}

export function getProductPaymentInfo({
  currentPrice,
  isVariable = false,
}: GetProductPaymentInfoOptions): ProductPaymentInfo {
  const normalizedPrice =
    Number.isFinite(currentPrice) && currentPrice >= 0 ? currentPrice : 0;
  const installments = maxCardInstallments(Math.round(normalizedPrice * 100), MAX_INSTALLMENTS);
  const installmentOptions = Array.from(
    { length: installments },
    (_, index): ProductInstallmentOption => ({
      installments: index + 1,
      installmentValue: normalizedPrice / (index + 1),
      total: normalizedPrice,
    }),
  );

  return {
    currentPrice: normalizedPrice,
    pixPrice: normalizedPrice * (1 - PIX_DISCOUNT_RATE),
    boletoPrice: normalizedPrice * (1 - BOLETO_DISCOUNT_RATE),
    installments,
    installmentValue: normalizedPrice / installments,
    installmentOptions,
    isVariable,
  };
}
